 <nav class="dash-nav">
     <ul class="dash-uls">
   <li><a [routerLink]="['browser']" routerLinkActive="active" >Browser</a></li>
   <li><a [routerLink]="['videos']" routerLinkActive="active">Videos</a></li>
   <li><a [routerLink]="['posts']" routerLinkActive="active">Posts</a></li>
   <li><a [routerLink]="['panel']" routerLinkActive="active" >Dashboard</a></li>
   <div class="icons">
       <li class="button"><button>Beta</button></li>
       <li class="notification">
         <div>
          <svg id="bell-solid-badged-notification" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20.95" height="20.81" viewBox="0 0 31.95 33.281">
            <defs>
              <clipPath id="clip-path">
                <path id="Mask" d="M12.27,30.225H17.53a2.672,2.672,0,0,1-2.58,2.281h-.038A2.671,2.671,0,0,1,12.27,30.225ZM0,29.175V26.355l.34-.3a14.363,14.363,0,0,0,2.47-2.93,12.618,12.618,0,0,0,1.35-4.81v-4.94a10.81,10.81,0,0,1,9.3-10.73V1.335a1.335,1.335,0,0,1,2.669,0v1.26a10.592,10.592,0,0,1,3.32,1v.63a7.5,7.5,0,0,0,5.99,7.36,10.947,10.947,0,0,1,.159,1.79v4.94a12.65,12.65,0,0,0,1.35,4.81,14.413,14.413,0,0,0,2.51,2.93l.34.3v2.821Z" transform="translate(0.05 0.775)" fill="#8939ad"/>
              </clipPath>
            </defs>
            <g id="mask-2" data-name="mask" transform="translate(-0.05)">
              <path id="Mask-3" data-name="Mask" d="M12.27,30.225H17.53a2.672,2.672,0,0,1-2.58,2.281h-.038A2.671,2.671,0,0,1,12.27,30.225ZM0,29.175V26.355l.34-.3a14.363,14.363,0,0,0,2.47-2.93,12.618,12.618,0,0,0,1.35-4.81v-4.94a10.81,10.81,0,0,1,9.3-10.73V1.335a1.335,1.335,0,0,1,2.669,0v1.26a10.592,10.592,0,0,1,3.32,1v.63a7.5,7.5,0,0,0,5.99,7.36,10.947,10.947,0,0,1,.159,1.79v4.94a12.65,12.65,0,0,0,1.35,4.81,14.413,14.413,0,0,0,2.51,2.93l.34.3v2.821Z" transform="translate(0.05 0.775)" fill="#8939ad"/>
              <g id="mask-4" data-name="mask" clip-path="url(#clip-path)">
                <g id="color" transform="translate(-3 -1)">
                  <rect id="Rectangle" width="36" height="36" fill="#fff"/>
                </g>
              </g>
            </g>
            <circle id="Oval" cx="5" cy="5" r="5" transform="translate(21.95)" fill="#f52f22"/>
          </svg>
         </div>
       
      </li>
       <li class="user-profile">
       <div>
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="50" height="50" viewBox="0 0 311 311">
          <defs>
            <linearGradient id="linear-gradient" x1="-0.126" y1="0.549" x2="0.753" y2="0.594" gradientUnits="objectBoundingBox">
              <stop offset="0" stop-color="#5c3aed"/>
              <stop offset="0.623" stop-color="#6851c9" stop-opacity="0.667"/>
              <stop offset="0.699" stop-color="#756ba1" stop-opacity="0.302"/>
              <stop offset="0.707" stop-color="#797296" stop-opacity="0.2"/>
              <stop offset="0.803" stop-color="#7a7592" stop-opacity="0.161"/>
              <stop offset="1" stop-color="gray" stop-opacity="0"/>
            </linearGradient>
            <pattern id="pattern" preserveAspectRatio="xMidYMid slice" width="100%" height="100%" viewBox="0 0 500 750">
              <image width="500" height="750" href="../../../assets/svg/user/img1.jpeg"></image></pattern>
          </defs>
          <g id="Group_23" data-name="Group 23" transform="translate(-17894.345 810.655)">
            <circle id="Ellipse_1" data-name="Ellipse 1" cx="155.5" cy="155.5" r="155.5" transform="translate(17894.344 -810.655)" fill="url(#linear-gradient)"/>
            <g id="photo-1545946551-0b395ce5b5f4" transform="translate(17919.344 -785.655)" stroke="#707070" stroke-width="1" fill="url(#pattern)">
              <circle cx="131" cy="131" r="131" stroke="none"/>
              <circle cx="131" cy="131" r="130.5" fill="none"/>
            </g>
          </g>
        </svg>
       </div>
        
      </li>
       <!-- generate a svg with two circles -->
   </div>
     </ul>
 </nav>